import { normalize } from 'normalizr';
import type { SummaryPage } from '../../../model';
import type { RestSummaryResponse } from '../../../rest/types';
import { preprocessSummary } from './preprocessors';
import summarySchema from './schema';

export const normalizeSummary = (restSummaryResponse: RestSummaryResponse): SummaryPage => {
	const preprocessedSummary = preprocessSummary(restSummaryResponse);
	return normalize(preprocessedSummary, summarySchema);
};
